import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NoticeService } from '../services/notice.service';

@Component({
  selector: 'ic-notice-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (notice of notices.visible(); track notice.key) {
      <div
        class="ic-notice"
        [class]="'ic-notice--' + notice.level.toLowerCase()"
        role="status"
      >
        <div class="ic-notice__content">
          <span class="ic-notice__title">{{ notice.title }}</span>
          <span>{{ notice.message }}</span>
        </div>
        @if (notice.dismissible) {
          <button
            type="button"
            class="ic-notice__dismiss"
            aria-label="Dismiss announcement"
            (click)="notices.dismiss(notice)"
          >
            &times;
          </button>
        }
      </div>
    }
  `,
  styles: [
    `
      .ic-notice {
        position: sticky;
        top: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 10px 16px;
        border-bottom: 1px solid;
        font-size: 13px;
        font-weight: 500;
      }

      .ic-notice--info {
        background: #e6f4ff;
        border-color: #91caff;
        color: #0958d9;
      }

      .ic-notice--warning {
        background: #fff7e6;
        border-color: #ffd591;
        color: #ad4e00;
      }

      .ic-notice--critical {
        background: #fff1f0;
        border-color: #ffa39e;
        color: #a8071a;
      }

      .ic-notice__content {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        gap: 4px 12px;
        align-items: center;
        justify-content: center;
        text-align: center;
      }

      .ic-notice__title {
        text-transform: uppercase;
        letter-spacing: 0.08em;
      }

      .ic-notice__dismiss {
        flex: none;
        padding: 0 4px;
        border: 0;
        background: none;
        color: inherit;
        font-size: 18px;
        line-height: 1;
        cursor: pointer;
        opacity: 0.7;
      }

      .ic-notice__dismiss:hover {
        opacity: 1;
      }
    `,
  ],
})
export class IcNoticeBannerComponent {
  protected readonly notices = inject(NoticeService);
}
